import React from "react";
import { connect } from 'react-redux';
import TosNavBar from "components/Navbars/TosNavBar.jsx";
import { setBeacon } from '../../redux/actions/rLink.action';
import { getInit } from '../../redux/actions/init.action';
import Footer from "components/Footer/Footer.jsx";

class Privacy extends React.Component {
    constructor(props) {
      super(props);
    }
    componentDidMount = async () => {
      await this.props.getInit();
      setTimeout(() => {
        const beacon = document.getElementById(typeof(chrome) == "object" ? "chromeAddon" : "mozAddon");
        const isPresent = beacon && beacon.innerHTML === "1.0.1";
        this.props.setBeacon(isPresent);
      }, 250);
    }
    render() {
  return (
    <>
      <TosNavBar/>
      <div className="content">
        <div className="privacy">
          <div className="privacy-head">
            <h3>Privacy Policy</h3>
          </div>
          <div className="privacy-block">
            <div className="privacy-block-body">
              <p>
                  rustLink may change this Privacy Policy from time to time and
                  the change will take effect once the revised Privacy Policy is
                  available on this Application. The “last updated” date is at
                  the bottom of this Policy. Therefore, please refer to this
                  Privacy Policy each time you submit your personal information.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Data Controller and Owner</h4>
            <div className="privacy-block-body">
              <ul>
                <li>rustLink.io</li>
                <li>Owner contact email: support@rustlink.io</li>
              </ul>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Types of Data collected</h4>
            <div className="privacy-block-body">
              <p>
                Among the types of Personal Data that this Application
                collects, by itself or through third parties, there are:
                Cookies and Usage Data.
              </p>
              <p>
                Other Personal Data collected may be described in other
                sections of this privacy policy or by dedicated explanation
                text contextually with the Data collection.
              </p>
              <p>
                The Personal Data may be freely provided by the User, or
                collected automatically when using this Application.
              </p>
              <p>
                Any use of Cookies - or of other tracking tools - by this
                Application or by the owners of third party services used by
                this Application, unless stated otherwise, serves to identify
                Users and remember their preferences, for the sole purpose of
                providing the service required by the User.
              </p>
              <p>
                Failure to provide certain Personal Data may make it
                impossible for this Application to provide its services.
              </p>
              <p>
                {`Users are responsible for any Personal Data of third parties
                obtained, published or shared through this Application and
                confirm that they have the third party's consent to provide
                the Data to the Owner.`}
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Mode and place of processing the Data</h4>
            <div className="privacy-block-body">
              <p>
                The Data Controller processes the Data of Users in a proper
                manner and shall take appropriate security measures to prevent
                unauthorized access, disclosure, modification, or unauthorized
                destruction of the Data.
              </p>
              <p>
                The Data processing is carried out using computers and/or IT
                enabled tools, following organizational procedures and modes
                strictly related to the purposes indicated. In addition to the
                Data Controller, in some cases, the Data may be accessible to
                certain types of persons in charge, involved with the
                operation of the site (administration, sales, marketing,
                legal, system administration) or external parties (such as
                third party technical service providers, mail carriers,
                hosting providers, IT companies, communications agencies)
                appointed, if necessary, as Data Processors by the Owner. The
                updated list of these parties may be requested from the Data
                Controller at any time.
              </p>
            </div>
            <div className="privacy-block-body">
              <p>
                {`The Data is processed at the Data Controller's operating
                offices and in any other places where the parties involved
                with the processing are located. For further information,
                please contact the Data Controller.`}
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Retention time</h4>
            <div className="privacy-block-body">
              <p>
                The Data is kept for the time necessary to provide the service
                requested by the User, or stated by the purposes outlined in
                this document, and the User can always request that the Data
                Controller suspend or remove the data.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">How Do We Protect Your Information ?</h4>
            <div className="privacy-block-body">
              <p>
                We are committed to protecting your privacy and we implement
                various security measures in relation to our processing and
                transfer of personal data. However, the nature of the Internet
                is such that the data may in some circumstances flow over
                networks without full security measures and could be
                accessible to unauthorized persons.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">How Do We Use Your Information ?</h4>
            <div className="privacy-block-body">
              <p>
                We will use your personal information for our legitimate
                interests to respond to your enquiries, to send information to
                you, to fulfil any contractual obligation to you, for research
                purposes, to send marketing information to you regarding our
                goods, services and related opportunities, and other
                reasonable uses by virtue of your affirmative consent.
              </p>
              <p>
                If you purchase goods or services from us we may send you
                further information that is related to your purchase, by post,
                push notification or e-mail.
              </p>
              <p>
                We would like to send you marketing information, by push
                notifications and e-mail.
              </p>
              <p>
                If you do not wish to receive any of the above information or
                be contacted by us in accordance with the above, please select
                the “Unsubscribe” button on our email, or write to the
                rustLink at the address below.
              </p>
              <p>
                If you submit your views to us via our contact form we may
                circulate them internally for training and management
                purposes.
              </p>
              <p>
                We review the Personal Information we collect periodically to
                determine its accuracy and whether it can be deleted.
              </p>
              <p>
                We may aggregate the information you send to us with other
                data (so that you cannot be identified from that data) and use
                that aggregated data for administrative purposes.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Push notifications</h4>
            <div className="privacy-block-body">
              <p>This Application may send push notifications to the User.</p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Analytics</h4>
            <div className="privacy-block-body">
              <p>
                The services contained in this section enable the Owner to
                monitor and analyze web traffic and can be used to keep track
                of User behavior.
              </p>
              <p>Google Analytics (Google Inc.)</p>
              <p>
                Google Analytics is a web analysis service provided by Google
                Inc. (“Google”). Google utilizes the Data collected to track
                and examine the use of this Application, to prepare reports on
                its activities and share them with other Google services.
              </p>
              <p>
                Google may use the Data collected to contextualize and
                personalize the ads of its own advertising network.
              </p>
              <p>Personal Data collected: Cookies and Usage Data.</p>
              <p>Place of processing: US – Privacy Policy – Opt Out.</p>
              <p>Google AdWords conversion tracking (Google Inc.)</p>
              <p>
                Google AdWords conversion tracking is an analytics service
                provided by Google Inc. that connects data from the Google
                AdWords advertising network with actions performed on this
                Application.
              </p>
              <p>Personal Data collected: Cookies and Usage Data.</p>
              <p>Place of processing: US – Privacy Policy.</p>
              <p>Twitter Ads conversion tracking (Twitter, Inc.)</p>
              <p>
                Twitter Ads conversion tracking is an analytics service
                provided by Twitter, Inc. that connects data from the Twitter
                advertising network with actions performed on this
                Application.
              </p>
              <p>Personal Data collected: Cookies and Usage Data.</p>
              <p>Place of processing: US – Privacy Policy.</p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">The rights of Users</h4>
            <div className="privacy-block-body">
              <p>
                Users may exercise certain rights regarding their Data
                processed by the Owner.
              </p>
              <p>In particular, Users have the right to do the following:</p>
              <p>
                Withdraw their consent at any time. Users have the right to
                withdraw consent where they have previously given their
                consent to the processing of their Personal Data.
              </p>
              <p>
                Object to processing of their Data. Users have the right to
                object to the processing of their Data if the processing is
                carried out on a legal basis other than consent. Further
                details are provided in the dedicated section below.
              </p>
              <p>
                Access their Data. Users have the right to learn if Data is
                being processed by the Owner, obtain disclosure regarding
                certain aspects of the processing and obtain a copy of the
                Data undergoing processing.
              </p>
              <p>
                Verify and seek rectification. Users have the right to verify
                the accuracy of their Data and ask for it to be updated or
                corrected.
              </p>
              <p>
                Restrict the processing of their Data. Users have the right,
                under certain circumstances, to restrict the processing of
                their Data. In this case, the Owner will not process their
                Data for any purpose other than storing it.
              </p>
              <p>
                Have their Personal Data deleted or otherwise removed. Users
                have the right, under certain circumstances, to obtain the
                erasure of their Data from the Owner.
              </p>
              <p>
                {`Receive their Data and have it transferred to another
                controller. Users have the right to receive their Data in a
                structured, commonly used and machine readable format and, if
                technically feasible, to have it transmitted to another
                controller without any hindrance. This provision is applicable
                provided that the Data is processed by automated means and
                that the processing is based on the User's consent, on a
                contract which the User is part of or on pre-contractual
                obligations thereof.`}
              </p>
              <p>
                Lodge a complaint. Users have the right to bring a claim
                before their competent data protection authority.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h3>Definitions and legal references</h3>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Personal Data (or Data)</h4>
            <div className="privacy-block-body">
              <p>
              Any information that directly, indirectly, or in connection
              with other information — including a personal identification
              number — allows for the identification or identifiability of a
              natural person.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Usage Data</h4>
            <div className="privacy-block-body">
              <p>
                {`Information collected automatically through this Application
                (or third-party services employed in this Application), which
                can include: the IP addresses or domain names of the computers
                utilized by the Users who use this Application, the URI
                addresses (Uniform Resource Identifier), the time of the
                request, the method utilized to submit the request to the
                server, the size of the file received in response, the
                numerical code indicating the status of the server's answer
                (successful outcome, error, etc.), the country of origin, the
                features of the browser and the operating system utilized by
                the User, the various time details per visit (e.g., the time
                spent on each page within the Application) and the details
                about the path followed within the Application with special
                reference to the sequence of pages visited, and other
                parameters about the device operating system and/or the User's
                IT environment.`}
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">User</h4>
            <div className="privacy-block-body">
              <p>
                The individual using this Application who, unless otherwise
                specified, coincides with the Data Subject.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Data Subject</h4>
            <div className="privacy-block-body">
              <p>The natural person to whom the Personal Data refers.</p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Data Processor (or Data Supervisor)</h4>
            <div className="privacy-block-body">
              <p>
                The natural or legal person, public authority, agency or other
                body which processes Personal Data on behalf of the
                Controller, as described in this privacy policy.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Data Controller (or Owner)</h4>
            <div className="privacy-block-body">
              <p>
                The natural or legal person, public authority, agency or other
                body which, alone or jointly with others, determines the
                purposes and means of the processing of Personal Data,
                including the security measures concerning the operation and
                use of this Application. The Data Controller, unless otherwise
                specified, is the Owner of this Application.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">This Application</h4>
            <div className="privacy-block-body">
              <p>
                The means by which the Personal Data of the User is collected
                and processed.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Service</h4>
            <div className="privacy-block-body">
              <p>
                The service provided by this Application as described in the
                relative terms (if available) and on this site/application.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">European Union (or EU)</h4>
            <div className="privacy-block-body">
              <p>
                Unless otherwise specified, all references made within this
                document to the European Union include all current member
                states to the European Union and the European Economic Area.
              </p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">Cookies</h4>
            <div className="privacy-block-body">
              <p>{`Small piece of data stored in the User's device.`}</p>
            </div>
          </div>
          <div className="privacy-block">
            <h4 className="text-center">rustLink relative information</h4>
            <div className="privacy-block-body">
              <ul>
                <li>Contact email: support@rustlink.io</li>
                <li>Last updated: September 23, 2021</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer fluid />
            </>
        )};
};

const mapDispatchToProps = {
    setBeacon,
    getInit
};

export default connect(null, mapDispatchToProps)(Privacy);
